const condominiumData = {
  name: "Raízes Residencial Clube",

  hero: {
    label: "RAÍZES RESIDENCIAL CLUBE",
    title: "Um novo jeito de viver em Sapucaia do Sul",
    description:
      "Apartamentos de 2 dormitórios com sacada e churrasqueira, em um condomínio com estrutura de lazer e espaços pensados para toda a família.",
  },

  location: {
    title: "Uma localização que conecta você a tudo",
    description: [
      "O Raízes Residencial Clube está localizado na Rua José Loureiro da Silva, 739, no bairro Pasqualini, em Sapucaia do Sul.",
      "A região oferece acesso a escolas, mercados, serviços de saúde e outras conveniências do dia a dia, além de estar próxima ao centro da cidade.",
    ],
    address:
      "Rua José Loureiro da Silva, 739 - Pasqualini, Sapucaia do Sul - RS",
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=Rua+José+Loureiro+da+Silva,+739,+Pasqualini,+Sapucaia+do+Sul+-+RS",
  },

  infrastructure: {
    title: "Estrutura de condomínio clube",
    description:
      "O empreendimento conta com diferentes espaços de lazer, convivência e serviços para proporcionar mais praticidade e qualidade de vida aos moradores.",
    items: [
      "Piscina adulto e infantil",
      "Salão de festas com churrasqueira",
      "Quiosques com churrasqueira",
      "Quadra poliesportiva",
      "Playground",
      "Espaço pet",
      "Academia ao ar livre",
      "Espaço coworking",
      "Bicicletário",
      "Condomínio fechado",
      "Elevador por torre",
      "Estacionamento",
    ],
  },

  plants: {
    title: "Conheça as plantas",
    description:
      "O Raízes Residencial Clube possui apartamentos de 2 dormitórios, todos com sacada. As unidades possuem diferentes configurações de planta.",
    items: [
      {
        title: "2 dormitórios — Apartamento de ponta",
        description:
          "Apartamento com 2 dormitórios e aproximadamente 47,16 m² de área privativa.",
        image: "",
      },
      {
        title: "2 dormitórios — Apartamento de meio",
        description:
          "Apartamento com 2 dormitórios e aproximadamente 46,70 m² de área privativa.",
        image: "",
      },
    ],
  },

  units: {
    title: "Encontre a unidade ideal",
    description:
      "Na primeira fase do empreendimento serão entregues as torres A e B. As unidades possuem 2 dormitórios, sacada e 1 vaga de estacionamento.",
    items: [
      {
        number: "47,16 m²",
        title: "Apartamento de ponta",
        description: "2 dormitórios • 1 vaga • sacada",
      },
      {
        number: "46,70 m²",
        title: "Apartamento de meio",
        description: "2 dormitórios • 1 vaga • sacada",
      },
    ],
  },

  gallery: {
    title: "Conheça o empreendimento",
    images: [],
  },

  contact: {
    label: "FALE CONOSCO",
    title: "Quer conhecer o Raízes Residencial Clube?",
    description:
      "Entre em contato com a Dalmo Souza e consulte as unidades disponíveis e as condições do empreendimento.",
    whatsapp: "https://wa.me/51995513505",
  },
};

export default condominiumData;
